import { isset } from "@Core/utils/Utils";
export class LocalStorageOptionsModel {
    constructor(data) {
        this.expandKey = true;
        this.isSecureValue = true;
        this.isJson = true;
        if (!data)
            return;
        this.expandKey = isset(data.expandKey) ? data.expandKey : this.expandKey;
        this.isSecureValue = isset(data.isSecureValue) ? data.isSecureValue : this.isSecureValue;
        this.isJson = isset(data.isJson) ? data.isJson : this.isJson;
    }
}
